import formatTime from './formatTime';

const formatSeconds = (timestamp) => {
  var timeData = formatTime(new Date(timestamp));
  return `${timeData.sec}:${timeData.milli}`;
};

export default formatSeconds;
